import React from 'react';
import { CcLoader } from '@utp/components-react';
import OutsideClickHandler from 'react-outside-click-handler';
import parse from 'html-react-parser';
import {
  Wrapper,
  InputText,
  ContainerSearchWithIcon,
  BtnSearch
} from './styled';
import { Icon } from '../../components';
import IDHelpers from '../../../core/helpers/IDHelper';

interface InputSearchProps {
  disabled?: boolean;
  error?: string;
  filterMetadata: any[];
  isLoadingData: boolean;
  onChange: (e: any) => void;
  selectItem: (value: any) => void;
  value: string;
  tabIndexInput?: number;
  tabIndexButton?: number;
}
const InputSearch = ({
  disabled,
  error,
  filterMetadata,
  isLoadingData,
  onChange,
  selectItem,
  value,
  tabIndexInput,
  tabIndexButton
}: InputSearchProps) => (
  <Wrapper
    className={`${value ? 'filled' : ''} ${error ? 'error' : ''} ${
      disabled ? 'disabled' : ''
    }`}
  >
    <ContainerSearchWithIcon>
      <InputText
        data-testid="cmp-inputSearch"
        disabled={disabled}
        type="text"
        id="inputSearch"
        placeholder="Buscar aquí"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        autoComplete="off"
        tabIndex={tabIndexInput}
        onKeyDown={(e) => {
          if (e.key === 'Tab') {
            e.preventDefault();
            (
              document.querySelector(
                '[data-testid="cmp-inputSearch-btn"]'
              ) as HTMLInputElement
            )?.focus();
          }
        }}
      />
      <BtnSearch
        data-testid="cmp-inputSearch-btn"
        type="button"
        disabled={disabled}
        onClick={() => {
          if (value) {
            onChange('');
            document.getElementById('inputSearch')?.focus();
          }
        }}
        tabIndex={tabIndexButton}
      >
        {isLoadingData ? (
          <CcLoader size={20} className="searchLoader" />
        ) : (
          <Icon name={value ? 'x' : 'search'} size={24} color="#5B36F2" />
        )}
      </BtnSearch>
    </ContainerSearchWithIcon>

    {value && (
      <div className="menu-wrapper boxShadow" data-testid="cmp-menu-wrapper">
        <OutsideClickHandler
          onOutsideClick={() => {
            onChange('');
            const inputS = document.getElementById('inputSearch');
            inputS?.focus();
          }}
        >
          <ul>
            {filterMetadata?.map((meta: any) => {
              const newValue = value.replaceAll(' ', '|');
              const newName = meta.name.replaceAll(' ', '|');
              let text1 = newName.replaceAll(
                newValue,
                `<mark>${newValue}</mark>`
              );
              text1 = text1.replaceAll('|', '&nbsp;');
              return (
                <li key={IDHelpers.generateIDStr()}>
                  <button
                    type="button"
                    onClick={() => selectItem(meta)}
                    data-testid="cmp-button-article-found"
                  >
                    {parse(text1)}
                  </button>
                </li>
              );
            })}
            {filterMetadata === undefined ||
              (filterMetadata.length === 0 && (
                <li key={IDHelpers.generateIDStr()}>
                  <button type="button" className="empty">
                    <Icon name="info" size={20} color="var(--info)" />
                    No se ha encontrado resultado
                  </button>
                </li>
              ))}
          </ul>
        </OutsideClickHandler>
      </div>
    )}
  </Wrapper>
);

InputSearch.defaultProps = {
  disabled: false,
  error: ''
};

export default InputSearch;
